export default "<p>notifs-digicod works!</p>\n"